import { Component, OnDestroy, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs/esm';

import { forkJoin } from 'rxjs';
import { AccountService } from './core/auth/account.service';
import { L10n } from '@syncfusion/ej2-base';
import i18nLocale from '../assets/i18n/syncfusion/locale.json';
import { ListenerService } from './core/listener/listener.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
	private renderer: Renderer2;

	/**
	 * Constructor
	 */
	constructor(
		private accountService: AccountService,
		private titleService: Title,
		private router: Router,
		private translateService: TranslateService,
		rootRenderer: RendererFactory2,
		private _listenerService: ListenerService
	) {
		this.renderer = rootRenderer.createRenderer(document.querySelector('html'), null);
		L10n.load(i18nLocale);
		this._listenerService.messageSystem().subscribe((data) => {
			console.log(data);
		});
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// try to log in automatically
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.updateTitle();
			}
		});

		this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
			this.updateTitle();
			dayjs.locale(langChangeEvent.lang);
			this.renderer.setAttribute(document.querySelector('html'), 'lang', langChangeEvent.lang);
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------

	private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
		const title: string = routeSnapshot.data['pageTitle'] ?? 'empty';
		if (routeSnapshot.firstChild) {
			return this.getPageTitle(routeSnapshot.firstChild) || title;
		}
		return title;
	}

	private updateTitle(): void {
		const pageTitleRoot = 'global.title';
		const pageTitle = this.getPageTitle(this.router.routerState.snapshot.root) || 'global.empty';
		forkJoin({
			titlePageRoot: this.translateService.get(pageTitleRoot),
			titlePage: this.translateService.get(pageTitle),
		}).subscribe((data: any[string]) => {
			const title =
				data.titlePage.length > 0
					? data.titlePageRoot + ' - ' + data.titlePage
					: data.titlePageRoot;
			this.titleService.setTitle(title);
		});
	}
}
